import { useCallback } from 'react';

import { useAppSelector } from '@/shared/hooks';

import { userModel } from '@/entities/user';

import { getCountryName } from '../lib';

import { useCountriesData } from './useCountriesData';

export const useCountryName = () => {
  const { countries, isLoading } = useCountriesData();

  const { locale } = useAppSelector(userModel.selectors.selectUserSettings);

  return useCallback(
    (countryCode?: string): string => {
      // Falling back to the code while the dataset is still in flight would
      // flash an ISO code in place of every country name. Once the load has
      // settled the code is the best that is left for a country the dataset
      // does not know, a failed chunk included.
      if (!countryCode || isLoading) {
        return '';
      }

      return getCountryName(
        countryCode,
        countries[countryCode]?.names ?? {},
        locale,
      );
    },
    [countries, isLoading, locale],
  );
};
